import React, { useEffect, useState } from 'react'
import {
	Button,
	TextField,
	Checkbox,
	FormControlLabel,
	Box,
	Typography,
} from '@mui/material'
import statusStore from '../../../stores/statusStore'
import StatusesList from './StatusesList'
import { observer } from 'mobx-react-lite'
import logger from '../../../utils/logger'

const Statuses = observer(() => {
	const statuses = statusStore.statuses
	const [showForm, setShowForm] = useState(false)
	const [showForClient, setShowForClient] = useState(false)

	// Состояния для полей формы
	const [statusName, setStatusName] = useState('')
	const [statusColor, setStatusColor] = useState('#009000')
	const [clientStatusName, setClientStatusName] = useState('')

	const mayManage = statusStore.canManageDictionaries

	// При монтировании компонента загружаем статусы, если они ещё не загружены
	useEffect(() => {
		if (statusStore.statuses.length === 0) {
			statusStore.fetchStatuses()
		}
	}, [])

	const handleToggleForm = () => {
		setShowForm(prev => !prev)
	}

	const handleCancel = () => {
		// Сброс значений и скрытие формы
		setStatusName('')
		setStatusColor('#009000')
		setClientStatusName('')
		setShowForClient(false)
		setShowForm(false)
	}

	const handleSave = () => {
		// Здесь можно добавить логику сохранения данных
		logger.log('Сохранено:', {
			statusName,
			statusColor,
			clientStatusName: showForClient ? clientStatusName : null,
		})

		const newStatus = {
			statusName,
			statusColor,
			clientStatusName: showForClient ? clientStatusName : null,
		}

		statusStore.addStatus(newStatus)

		// Сброс значений и скрытие формы после сохранения
		setStatusName('')
		setStatusColor('#000000')
		setClientStatusName('')
		setShowForClient(false)
		setShowForm(false)
	}

	return (
		<>
			<Box className='mt-4 p-4 rounded shadow'>
				{/* временно скрыто, не реализована логика */}
				{/* 	<Typography variant='h6' className='font-semibold text-lg'>
					Статусы объектов в заявках
				</Typography>
				<div className='mt-4'>
					<StatusesList statuses={statuses} />
				</div> */}
				{/* <Box mt={2}>
					<Button variant='outlined' size='small' onClick={handleToggleForm}>
						Добавить статус
					</Button>
				</Box> */}
				{mayManage && showForm && (
					<Box
						mt={2}
						sx={{
							border: '1px solid #ccc',
							padding: 2,
							borderRadius: 1,
							maxWidth: 400,
						}}
					>
						<TextField
							label='Название статуса'
							value={statusName}
							onChange={e => setStatusName(e.target.value)}
							fullWidth
							margin='normal'
						/>

						<Box mt={2}>
							<Typography variant='subtitle1'>Цвет статуса</Typography>
							<input
								type='color'
								value={statusColor}
								onChange={e => setStatusColor(e.target.value)}
								style={{
									width: '100%',
									height: '40px',
									border: 'none',
									padding: 0,
									background: 'none',
									cursor: 'pointer',
								}}
							/>
						</Box>

						<FormControlLabel
							control={
								<Checkbox
									checked={showForClient}
									onChange={e => setShowForClient(e.target.checked)}
								/>
							}
							label='Показывать клиенту?'
							sx={{ mt: 2 }}
						/>

						{showForClient && (
							<TextField
								label='Название для клиента'
								value={clientStatusName}
								onChange={e => setClientStatusName(e.target.value)}
								fullWidth
								margin='normal'
							/>
						)}

						{/* Кнопки Отмена и Сохранить */}
						<Box mt={2} display='flex' justifyContent='flex-end' gap={1}>
							<Button variant='outlined' onClick={handleCancel}>
								Отмена
							</Button>
							<Button variant='contained' onClick={handleSave}>
								Сохранить
							</Button>
						</Box>
					</Box>
				)}
			</Box>
		</>
	)
})

export default Statuses
